// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nh-9";
export var arrowButtonContainer = "_nh-5";
export var arrowButtonIcon = "_nh-6";
export var carouselArrowButton = "_nh-2";
export var carouselElementContainer = "_nh-1";
export var currentSlide = "_nh-8";
export var left = "_nh-3";
export var otherSlide = "_nh-a";
export var productCarouselContainer = "_nh-0";
export var right = "_nh-4";
export var sliderOverflow = "_nh-7";